'use strict';

class RecipientList {
  constructor($filter, recipientService, labelService, originatorService, reportService) {
    this.$filter = $filter;
    this.recipientService = recipientService;
    this.labelService = labelService;
    this.originatorService = originatorService;
    this.reportService = reportService;
  }

  $onInit() {
    this.selectedFilter = 'all';

    this.offset = 0;
    this.limit = 25;
    this.currentPage = 1;

    this.recipients = [];
    this.total = 0;
    this.name = null;

    this.list = {
      alphabet: [],
      city: [],
      country: [],
      label: [],
      customField: []
    };

    this.filters = {
      city: 0,
      country: 0,
      label: 0,
      customField: 0,
      letter: 0
    };

    this.field = {};
    this.customFieldNumber = null;

    // sorting
    this.predicate = 'name';
    this.reverse = false;

    this.order = (predicate) => {
      this.reverse = this.predicate === predicate ? !this.reverse : false;
      this.predicate = predicate;
    };

    this.naturalComparator = function(a, b) {
      if (a.type !== 'string' || b.type !== 'string') {
        return (a.index < b.index) ? -1 : 1;
      }

      return a.value.localeCompare(b.value, undefined, {
        numeric: true,
        sensitivity: 'base'
      });
    };

    // check originator
    this.reportParams = '';
    this.originatorService.get()
      .then((resp) => {
        this.originator = resp.data;
        if (resp.data && resp.data.bankAccount && resp.data.bankAccount.avtaleGiro) {
          this.reportParams = ',kid,activeAgiroAgreement';
        }
      });

    // load filters
    this.recipientService.filter('alphabet')
      .then((resp) => {
        this.list.alphabet = resp.letters;
      });

    this.recipientService.filter('city')
      .then((resp) => {
        this.list.city = resp.cities;
      });

    this.recipientService.filter('country')
      .then((resp) => {
        this.list.country = resp.countries;
      });

    this.labelService.list()
      .then((resp) => {
        this.list.label = resp.data;
      });

    this.recipientService.getCustomFields()
      .then((resp) => {
        this.list.customField = resp.data;
      });

    this.filter();

    $('select.custom-select').each(function () {
      new Select({ // eslint-disable-line
        el: this
      });
    });
  }

  success(data) {
    if (data) {
      this.recipients = data.recipient;
      this.total = data.total;
    }
  }

  search() {
    if (this.name.length > 1) {
      this.recipients = [];
      this.total = 0;

      this.recipientService.search(this.name, this.limit)
        .then((resp) => {
          this.recipients = [];
          resp.data.recipients.map((item) => {
            this.recipients.push({
              id: item.id,
              number: item.number,
              customerNumber: item.recipientNo,
              name: item.name
            });
          }, this);

          this.total = resp.data.total;
        });
    } else {
      this.filter();
    }
  }

  reset() {
    this.filters = {
      alphabet: 0,
      city: 0,
      country: 0,
      label: 0,
      customField: 0
    };

    this.field = {};
    this.customFieldNumber = null;

    this.offset = 0;
    this.limit = 25;
    this.currentPage = 1;

    this.filter();
  }

  changeLimit(val) {
    this.offset = 0;
    this.limit = val;
    this.currentPage = 1;

    this.filter(this.selectedFilter, this.filters[this.selectedFilter]);
  }

  changePage(next = false) {
    if (next) {
      this.offset = this.offset + this.limit;
      this.currentPage = this.currentPage + 1;
    } else {
      this.offset = this.offset - this.limit;
      this.currentPage = this.currentPage - 1;
    }

    this.filter(this.selectedFilter, this.filters[this.selectedFilter]);
  }

  numberOfPages() {
    return Math.ceil(this.total / this.limit);
  }

  /**
   * Load selected custom field options
   *
   * @param {Integer} number Selected custom field number
   * @returns {Array} Selected custom field options or values
   */
  loadCustomField(number) {
    this.recipientService.getCustomField(number)
      .then((resp) => {
        this.filters.customField = null;
        this.field = resp.data;
      });
  }

  /**
   * Filter recipient list
   *
   * @param {String} name Name of the filter
   * @param {String} query Query
   * @param {Integer} number Number for custom field
   * @returns {Array} Filtered list
   */
  filter(name = 'all', query = null, number = null) {
    const filters = {
      all: () => this.recipientService.list({
        offset: this.offset,
        limit: this.limit
      })
        .then((resp) => this.success(resp.data)),
      top10: () => this.recipientService.filter('mostUsed', {
        offset: this.offset,
        limit: this.limit
      })
        .then((resp) => this.success(resp)),
      alphabet: () => this.recipientService.getLetter(query, this.offset, this.limit)
        .then((resp) => this.success(resp.data)),
      city: () => this.recipientService.getCity(query, this.offset, this.limit)
        .then((resp) => this.success(resp.data)),
      country: () => this.recipientService.getCountry(query, this.offset, this.limit)
        .then((resp) => this.success(resp.data)),
      label: () => this.recipientService.list({
        offset: this.offset,
        limit: this.limit,
        labels: query
      })
        .then((resp) => this.success(resp.data)),
      customField: () => this.recipientService.getField(number, query)
        .then((resp) => this.success(resp.data))
    };

    if (name in filters) {
      // reset options if different filter is selected
      if (this.selectedFilter !== name) {
        this.offset = 0;
        this.limit = 25;
        this.currentPage = 1;
      }

      // set selected filter
      this.selectedFilter = name;

      this.filters = {
        alphabet: 0,
        city: 0,
        country: 0,
        label: 0,
        customField: 0
      };

      if (name === 'customField') {
        this.customFieldNumber = number;
        this.filters.customField = query;
      } else {
        this.field = {};
        this.customFieldNumber = null;
        this.filters[name] = query;
      }

      return filters[name]();
    }
  }

  export() {
    this.reportService.availableColumns('recipients')
      .then((resp) => {
        if (resp && resp.data) {
          let params = {
            format: 'XLS',
            columns: `${resp.data.map(data => data.key).join(',')}${this.reportParams}`
          };

          if (this.filters.label !== 0) {
            params.labelNumber = this.filters.label;
          }

          this.reportService.download('recipients', params);
        }
      });
  }
}

RecipientList.$inject = ['$filter', 'recipientService', 'labelService', 'originatorService', 'reportService'];

const recipientList = {
  controller: RecipientList,
  templateUrl: 'recipient/list.html'
};

angular
  .module('SendRegning')
  .component('recipientList', recipientList)
  .config(($routeProvider) => {
    $routeProvider
      .when('/kundeliste', {
        title: 'Kundeliste',
        template: '<recipient-list />',
        secure: true
      });
  });
